module.exports = __webpack_public_path__ + "static/img/defaultMTR.e2d84c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defaultMTR.png
// module id = iz49
// module chunks = 54